export const formatExpiryDate = (dateVal) => {
  if (!dateVal) return "";
  const date = dateVal.toDate ? dateVal.toDate() : new Date(dateVal);
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
};
